import React from 'react'
import UiInputTextarea from "../components/Form/UiInputTextarea";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import { useNotification } from '../components/Core/NotificationProvider';

/**
 * "Gerar versão" do grid de contratos. Recebe a linha do contrato e pede o motivo.
 *
 * Gerar **nunca** sobrescreve: cria a versão seguinte com o motivo, e a anterior
 * fica no histórico com o hash dela. Por isso o motivo é obrigatório a partir da
 * segunda: sem ele o histórico não explica por que existem duas.
 */
export default function ContratoVersaoForm(props: any){
    const contrato = props.data || {};
    const versaoAtual = Number(contrato.versao_atual) || 0;
    const primeira = versaoAtual < 1;

    const methods = useForm({ defaultValues: { motivo: '' } });
    const { handleSubmit } = methods;
    const notification = useNotification();

    const gerar = (dados: any) => {
        const motivo = String(dados.motivo || '').trim();
        if (!primeira && motivo === '') {
            notification.error('Informe o motivo da nova versão');
            return;
        }

        props.triggerSubmit({
            contrato: { id: contrato.id },
            motivo,
        });
    };

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(gerar)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <div className="col-lg-12">
                            <p className="text-muted small">
                                Contrato <b>#{contrato.id}</b> &middot; {contrato['instalador/nome']}
                                <br/>
                                {primeira
                                    ? 'Nenhuma versão gerada ainda: esta será a versão 1.'
                                    : `Versão atual: ${versaoAtual}. Esta geração cria a versão ${versaoAtual + 1} e mantém a anterior no histórico.`}
                            </p>
                        </div>
                        <UiInputTextarea
                            size={12}
                            name="motivo"
                            rows={3}
                            label={primeira ? 'Motivo (opcional na primeira versão)' : 'Motivo da nova versão'}
                        />
                        <div className="col-lg-12">
                            <p className="text-muted small" style={{ margin: 0 }}>
                                Gerar congela o documento em HTML, com o SHA-256 e o snapshot dos dados. O PDF é
                                produzido depois, pelo assinador, a partir desse HTML.
                            </p>
                        </div>
                    </div>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Gerar versão</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
